function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlusCircle = function SvgPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 22664"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17849",
    d: "M9 7v2m0 0v2m0-2h2M9 9H7m8 0a6 6 0 1 1-6-6 6 6 0 0 1 6 6Z",
    transform: "translate(.5 .5)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20163",
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  })));
};

export default SvgPlusCircle;